import FullCalendar from "@fullcalendar/react";
import listPlugin from "@fullcalendar/list";
import React, { useContext, useEffect, useState } from "react";
import { CrmContext } from "../../../../context";

export default () => {
  const context = useContext(CrmContext);
  const [list, setList] = useState([...context.trade.tasks]);

  useEffect(() => {
    const tmpList = [];

    context.trade.tasks.map((task) => {
      tmpList.push({
        ...task,
        start: formatDate(task.start_date),
        end: formatDate(task.due_date),
      });
    });
    setList(tmpList);
  }, [context.trade.tasks]);

  const formatDate = (task) => {
    const date = new Date(task),
      month = task.substring(3, 5),
      day = task.substring(0, 2),
      year = task.substring(6, 10);

    return [year, month, day].join("-");
  };

  const handleTasks = () => {
    return (
      <div className="p-30 w-100 task-custom-calendar">
        <FullCalendar
          // style={{ height: "440px" }}
          allDayText="Dia inteiro"
          events={list}
          locale="pt-BR"
          plugins={[listPlugin]}
          initialView="listWeek"
          selectable={false}
          noEventsContent="Não existem tarefas para essa negociação"
          headerToolbar={{
            left: null,
            center: "title",
            right: null,
          }}
          buttonText={{
            today: "Hoje",
            day: "Dia",
            month: "Mês",
            week: "Semana",
            list: "Lista",
          }}
        />
      </div>
    );
  };

  return <>{handleTasks()}</>;
};
